import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum BookmarkIconVariant {
  LINE = 'line',
  FILL = 'fill',
  ON = 'on',
  OFF = 'off',
}

export interface IBookmarkIconProps extends IConDefaultType {
  variant?: BookmarkIconVariant;
}

function BookmarkIcon({
  color,
  className,
  size = 38,
  rotate,
  flip,
  variant = BookmarkIconVariant.LINE,
}: IBookmarkIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === BookmarkIconVariant.LINE && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path
            transform="translate(4 3)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 2C4.20448 2 3.44146 2.31614 2.87882 2.879C2.31617 3.44188 2 4.20538 2 5.00158V15.2035C2.0007 15.337 2.03476 15.4683 2.09907 15.5853C2.1636 15.7027 2.25652 15.8019 2.36927 15.874C2.48203 15.9461 2.61103 15.9888 2.74447 15.9981C2.87791 16.0074 3.01156 15.983 3.13319 15.9272L6.75486 14.2758C6.75495 14.2758 6.75478 14.2759 6.75486 14.2758C7.14567 14.0975 7.57045 14.0052 8 14.0052C8.42955 14.0052 8.85408 14.0974 9.24488 14.2757C9.24497 14.2758 9.2448 14.2757 9.24488 14.2757L12.8668 15.9272C12.9884 15.983 13.1221 16.0074 13.2555 15.9981C13.389 15.9888 13.518 15.9461 13.6307 15.874C13.7435 15.8019 13.8364 15.7027 13.9009 15.5853C13.9653 15.4683 13.9993 15.337 14 15.2034V5.00158C14 4.20538 13.6838 3.44188 13.1212 2.879C12.5585 2.31614 11.7955 2 11 2H5ZM1.46433 1.46507C2.40198 0.527046 3.67379 0 5 0H11C12.3262 0 13.598 0.527046 14.5357 1.46507C15.4733 2.40307 16 3.6752 16 5.00158V15.2056L16 15.2091C15.9984 15.6776 15.8793 16.1381 15.6536 16.5487C15.4279 16.9592 15.1029 17.3066 14.7082 17.559C14.3135 17.8114 13.8618 17.9607 13.3944 17.9932C12.9274 18.0258 12.4597 17.9406 12.0341 17.7457C12.0338 17.7455 12.0335 17.7454 12.0332 17.7452L8.41512 16.0955C8.28486 16.036 8.14314 16.0052 8 16.0052C7.85686 16.0052 7.71539 16.0359 7.58514 16.0953L3.96681 17.7452C3.9665 17.7454 3.96619 17.7455 3.96587 17.7457C3.54027 17.9406 3.07257 18.0258 2.60555 17.9932C2.13819 17.9607 1.68649 17.8114 1.2918 17.559C0.897115 17.3066 0.572074 16.9592 0.346406 16.5487C0.12074 16.1381 0.00164557 15.6776 6.13928e-06 15.2091L0 15.2056V5.00158C0 3.6752 0.526688 2.40307 1.46433 1.46507Z"
            fill={color || '#4B4B4B'}
          />
        </svg>
      )}
      {variant === BookmarkIconVariant.FILL && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
          <path
            d="M11.3155 1.29932C11.7878 1.29932 12.2009 1.47163 12.5358 1.80661C12.8707 2.14151 13.0429 2.55429 13.0425 3.02628V14.0789C13.0425 14.1949 12.9841 14.303 12.8873 14.3669C12.7904 14.4308 12.6675 14.4423 12.5608 14.3966L7.86156 12.3822L3.16233 14.3966C3.05561 14.4423 2.93275 14.4308 2.83582 14.3669C2.73902 14.303 2.68066 14.1949 2.68066 14.0789V3.02628C2.68066 2.55401 2.85293 2.14118 3.18796 1.80661C3.52274 1.4724 3.93538 1.29995 4.40695 1.29932H11.3155Z"
            fill={color}
          />
        </svg>
      )}
      {variant === BookmarkIconVariant.OFF && (
        <svg viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="19" cy="19" r="18.5" stroke="#E3E5E8" />
          <path
            d="M16 11H22C23.0609 11 24.0783 11.4216 24.8284 12.172C25.5786 12.9225 26 13.9403 26 15.0016V25.2056C25.9989 25.5068 25.9224 25.803 25.7773 26.067C25.6322 26.3309 25.4232 26.5543 25.1695 26.7165C24.9157 26.8788 24.6254 26.9747 24.325 26.9957C24.0246 27.0166 23.7237 26.9618 23.45 26.8362L19.83 25.1856C19.5694 25.0667 19.2864 25.0052 19 25.0052C18.7136 25.0052 18.4306 25.0667 18.17 25.1856L14.55 26.8362C14.2763 26.9618 13.9754 27.0166 13.675 26.9957C13.3746 26.9747 13.0843 26.8788 12.8305 26.7165C12.5768 26.5543 12.3678 26.3309 12.2227 26.067C12.0776 25.803 12.0011 25.5068 12 25.2056V15.0016C12 13.9403 12.4214 12.9225 13.1716 12.172C13.9217 11.4216 14.9391 11 16 11Z"
            fill="#D8D8D8"
          />
        </svg>
      )}
      {variant === BookmarkIconVariant.ON && (
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="19" cy="19" r="18.5" stroke="#00C3DD" />
          <path
            d="M12.4643 11.4651C13.402 10.527 14.6738 10 16 10H22C23.3262 10 24.598 10.527 25.5357 11.4651C26.4733 12.4031 27 13.6752 27 15.0016V25.2056L27 25.2091C26.9984 25.6776 26.8793 26.1381 26.6536 26.5487C26.4279 26.9592 26.1029 27.3066 25.7082 27.559C25.3135 27.8114 24.8618 27.9607 24.3944 27.9932C23.9274 28.0258 23.4597 27.9406 23.0341 27.7457L23.0332 27.7452L19.4151 26.0955C19.2849 26.036 19.1431 26.0052 19 26.0052C18.8569 26.0052 18.7154 26.0359 18.5851 26.0953L14.9668 27.7452L14.9659 27.7457C14.5403 27.9406 14.0726 28.0258 13.6056 27.9932C13.1382 27.9607 12.6865 27.8114 12.2918 27.559C11.8971 27.3066 11.5721 26.9592 11.3464 26.5487C11.1207 26.1381 11.0016 25.6776 11 25.2091L11 25.2056V15.0016C11 13.6752 11.5267 12.4031 12.4643 11.4651Z"
            fill="#00C3DD"
          />
        </svg>
      )}
    </i>
  );
}

export default BookmarkIcon;
